import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import ApplicationStatus from "./layouts/ApplicationStatus";
import Loader from "./layouts/Loader";

function MyApplied() {
    const [applications, setApplications] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const formData = new FormData();
            formData.append("page", page);
            formData.append("time_zone", timeZone);
            formData.append("search", search);

            const response = await axios.post(
                baseUrl + "/api/jobs/my-applications",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setApplications(response.data.applications);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        fetch();
    }, []);

    const styles = {
        profileImage: {
            width: "100px",
            height: "100px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">My Application</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">My Application</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-0 wow fadeInUp" data-wow-delay="0.1s">My Applications</h1>

                    <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="container">

                            <div className="row mb-5">
                                <div className="offset-md-3 col-md-5">
                                    <input type="text" className="form-control" placeholder="Search..."
                                        value={ search }
                                        onChange={ function (event) {
                                            setSearch(event.target.value || "");
                                        } }
                                        onKeyDown={ function (event) {
                                            if (event.key === "Enter") {
                                                fetch();
                                            }
                                        } } />
                                </div>

                                <div className="col-md-1">
                                    <button type="button" className="btn btn-primary"
                                        onClick={ function () {
                                            fetch();
                                        } }
                                        disabled={ loading }>Search</button>
                                </div>
                            </div>

                            { loading && (
                                <div className="row mb-5">
                                    <div className="col-md-12 text-center">
                                        <Loader />
                                    </div>
                                </div>
                            ) }

                            <div className="row">
                                <div className="col-md-12">
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Company</th>
                                                <th>CV</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            { applications.map(function (application) {
                                                return (
                                                    <tr key={ `application-${ application.id }` }>
                                                        <td>
                                                            <Link to={ `/application/${ application.id }` }>{ application.id }</Link>
                                                        </td>

                                                        <td>
                                                            { application.company.profile_image && (
                                                                <img src={ application.company.profile_image }
                                                                    style={ styles.profileImage } />
                                                            ) }
                                                            
                                                            <p>{ application.company.name }</p>
                                                        </td>

                                                        <td>
                                                            <a href={ application.cv.path }
                                                                target="_blank">{ application.cv.title }</a>
                                                        </td>

                                                        <td>
                                                            <ApplicationStatus status={ application.status } />
                                                        </td>
                                                    </tr>
                                                );
                                            }) }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MyApplied;